export const FAQS = [
  {
    q: '黑料百科主要收录哪一类内容？',
    a: '我们专注冷门、小众、早期、被删与尘封的网络内容。具体包括早期论坛与聊天室往事、下架或删除的节目与帖子、小众亚文化圈子、停运的老游戏，以及那些已经打不开的老网站。凡是能被时间冲掉、又值得留个记录的东西，都是我们的挖掘对象。',
  },
  {
    q: '网站上的内容是怎么被整理出来的？',
    a: '每条档案都来自可追溯的原始材料，例如网友保存的网页存档、截图、软盘与光盘里的旧文件。档案员会先把材料归档编号，再交叉比对时间、版块与用户名，确认无误后才写成条目。无法验证的部分会在正文中明确标注为存疑。',
  },
  {
    q: '你们会挖掘真实人物的私人信息吗？',
    a: '不会。我们关注的始终是公开传播过的网络文化内容，不收集、不整理、也不发布任何人的隐私信息、联系方式或私人生活细节。档案中涉及具体网名的内容，也会按公开讨论范围处理，超出公共议题的部分一律不收。',
  },
  {
    q: '我可以提交自己保存的老网页或截图吗？',
    a: '当然可以。在页面底部的线索订阅区留下邮箱，或在关于我们页面找到线索投递地址，把材料的大致年份和来源说明写清楚即可。档案员会先做初步核对，如果入库会回信告知对应的档案编号。',
  },
  {
    q: '为什么有的条目标着「内容缺失」或「待考据」？',
    a: '有些内容只会剩下零碎痕迹，比如一张模糊截图或一句话的转述。与其强行补全，我们更愿意如实标出缺口，并把已知与未知分开写清楚。这样后来者接手时，能立刻知道还差哪一块。',
  },
  {
    q: '档案内容会更新或修正吗？',
    a: '会。档案不是一次写完就封存的。随着新线索出现，旧条目会被补充细节、订正错处，并在文末标注最近一次修订的时间与说明。如果你发现某条记录与事实不符，欢迎随时来信指出。',
  },
];